import 'unfetch/polyfill/index.js';
import 'es6-promise/auto';
import anime from 'animejs';
import mq from '../utils/mediaQueries';

const controlElement = document.documentElement;
const openFlag = 'flyout-is-open';
const toggleIcon = document.getElementById('flyout-menu-toggle');
const toggleIconAnimation = anime.timeline({
  easing: 'easeOutQuad',
  duration: 170,
  autoplay: false,
}).add({
  targets: toggleIcon.querySelector('.menu-toggle__line-1'),
  x1: [8,19],
  y1: [14,30],
  x2: [40,39],
  y2: [14,10],
}, 0).add({
  targets: toggleIcon.querySelector('.menu-toggle__line-2'),
  x1: [0,19],
  y1: [25,10],
  x2: [40,39],
  y2: [25,30],
}, 0);

export default {

  _bindEvents() {
    toggleIcon.addEventListener('click', () => this.toggle());

    document.addEventListener('keydown', (e) => {
      if ( e.key == 'Escape' ) this.close();
    });

    mq.minWidth('nav', () => this.close());
  },

  init() {
    this._bindEvents();
  },

  isOpen() {
    return controlElement.classList.contains(openFlag);
  },

  toggle() {
    toggleIconAnimation.play();
    toggleIconAnimation.finished.then(() => {
      toggleIconAnimation.reverse();
    });
    controlElement.classList.toggle(openFlag);
  },

  close() {
    if ( this.isOpen() ) this.toggle();
  },

  open() {
    if ( !this.isOpen() ) this.toggle();
  },

}
